import * as React from 'react';
import * as _ from 'lodash';
import { PARTS } from './../../schemas/accessRightsModel';
import * as Backend from '../../utilities/backend';
import HelpButton from '../../components/PageLayout/HelpButton';
import LanguageSwitcher from '../../components/PageLayout/LanguageSwitcher';
import GlobalMarkUpButton from '../../components/PageLayout/Header/GlobalMarkUpButton';
import CurrentUser from '../../components/PageLayout/Header/CurrentUser';
import NotificationsButton from '../../components/PageLayout/Header/NotificationsButton';
import PingPilotHeaderButton from '../../components/PageLayout/PingPilotHeaderButton';
import { Cookies } from 'cookies-js';
export default function () {
    function onClick1(AR) {
        {
            this.managingOpen = !this.managingOpen;
            this.forceUpdate();
        }
    }
    function onClick2(AR) {
        {
            this.managingOpen = !this.managingOpen;
            this.forceUpdate();
        }
    }
    function onClick3(AR) {
        {
            window.managing = 'BathDB';
            Cookies.set('managing', 'BathDB');
            this.props.go('/');
            this.managingOpen = false;
            this.forceUpdate();
        }
    }
    function onClick4(AR) {
        {
            window.managing = 'KitchenDB';
            Cookies.set('managing', 'KitchenDB');
            this.props.go('/');
            this.managingOpen = false;
            this.forceUpdate();
        }
    }
    function onClick5(AR) {
        this.props.go('/');
    }
    function onClick6(AR) {
        this.props.logout();
    }
    function scopeAR7() {
        var AR = this.props.AR;
        return React.createElement('div', { 'className': 'central-hub-global-wrapper' }, this.props.showGlobalMarkUpButton ? React.createElement(GlobalMarkUpButton, { 'key': '917' }) : null, React.createElement(CurrentUser, {}), this.props.auth.userExistsIn.kitchen && this.props.auth.userExistsIn.bathroom ? React.createElement('div', {
            'className': 'central-hub-toggle-container',
            'key': '1002'
        }, Backend.getManaging() == 'BathDB' ? React.createElement('div', {
            'className': 'central-hub-toggle-version ' + (this.managingOpen ? 'central-hub-toggle--open' : ''),
            'title': 'Version 9.0',
            'onClick': onClick1.bind(this, AR),
            'key': '1136'
        }, React.createElement('div', { 'className': 'central-hub-icon-desc' }, '9.0')) : null, Backend.getManaging() == 'KitchenDB' ? React.createElement('div', {
            'className': 'central-hub-toggle-version ' + (this.managingOpen ? 'central-hub-toggle--open' : ''),
            'title': 'Version 8.0 (Legacy)',
            'onClick': onClick2.bind(this, AR),
            'key': '1442'
        }, React.createElement('div', { 'className': 'central-hub-icon-desc' }, '8.0')) : null, this.managingOpen ? React.createElement('div', {
            'className': 'central-hub-bv-kv-menu',
            'key': '1760'
        }, React.createElement('ul', {}, React.createElement('li', {
            'className': 'central-hub-bv-kv-menu-item--version ' + (Backend.getManaging() == 'BathDB' ? 'central-hub-bv-kv-menu-item--version-active' : ''),
            'onClick': onClick3.bind(this, AR)
        }, 'Version 9.0'), React.createElement('li', {
            'className': 'central-hub-bv-kv-menu-item--version ' + (Backend.getManaging() == 'KitchenDB' ? 'central-hub-bv-kv-menu-item--version-active' : ''),
            'onClick': onClick4.bind(this, AR)
        }, 'Version 8.0 (Legacy)'))) : null) : null, !this.props.isEncore || AR.v(PARTS.HUB_BUTTON_DASHBOARD) ? React.createElement('div', {
            'className': 'central-hub-main-icon',
            'onClick': onClick5.bind(this, AR),
            'key': '2519'
        }, React.createElement('div', { 'className': 'central-hub-icon-desc' }, 'Main')) : null, React.createElement(LanguageSwitcher, {}), React.createElement(PingPilotHeaderButton, {}), React.createElement(HelpButton, {}), !this.props.isEncore ? React.createElement(NotificationsButton, { 'key': '2787' }) : null, React.createElement('div', {
            'className': 'central-hub-logout-icon',
            'onClick': onClick6.bind(this, AR)
        }, React.createElement('div', { 'className': 'central-hub-icon-desc' }, 'Logout')));
    }
    return scopeAR7.apply(this, []);
}